/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerDeleteKeyMutationResponse, ServiceAccountsControllerDeleteKeyPathParams, ServiceAccountsControllerDeleteKey401, ServiceAccountsControllerDeleteKey403, ServiceAccountsControllerDeleteKey404 } from "../../models/serviceAccountsController/ServiceAccountsControllerDeleteKey";

function getServiceAccountsControllerDeleteKeyUrl(orgId: ServiceAccountsControllerDeleteKeyPathParams["orgId"], keyId: ServiceAccountsControllerDeleteKeyPathParams["keyId"]) {
  const res = { method: 'DELETE', url: `/api/v1/organizations/${orgId}/api-keys/${keyId}` as const }  
  return res
}

/**
 * @summary Revoke a service account key
 * {@link /api/v1/organizations/:orgId/api-keys/:keyId}
 */
export async function serviceAccountsControllerDeleteKey(orgId: ServiceAccountsControllerDeleteKeyPathParams["orgId"], keyId: ServiceAccountsControllerDeleteKeyPathParams["keyId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ServiceAccountsControllerDeleteKeyMutationResponse, ResponseErrorConfig<ServiceAccountsControllerDeleteKey401 | ServiceAccountsControllerDeleteKey403 | ServiceAccountsControllerDeleteKey404>, unknown>({ method : "DELETE", url : getServiceAccountsControllerDeleteKeyUrl(orgId, keyId).url.toString(), ... requestConfig })  
  return res.data
}